import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MenuItem from "@material-ui/core/MenuItem";
import React, { useState } from "react";
import GeneralButton from "../../../../components/kit/GeneralButton/GeneralButton";
import InputForm from "../../../../components/kit/InputForm/InputForm";
import InputPhoneMask from "../../../../components/kit/InputPhoneMask/InputPhoneMask";
import SelectInput from "../../../../components/kit/SelectInput/SelectInput";
import { checkEmptyField } from "../../../../global/Helpers/checkEmptyField";
import { showGenderInput, privacyPolicyUrl } from "./../../../../constants.json";
import "../index.scss";

const ClientForm = ({
  name,
  lastname,
  sname,
  gender,
  phone,
  // email,
  // inn,
  // documentNumber,
  DateBirth,
  inputChangeHandler,
  handleClickPrev,
  createPatient,
}) => {
  const [consent, setConsent] = useState(false);
  const today = new Date().toISOString().split("T")[0];
  const isFutureDate = DateBirth && new Date(DateBirth) > new Date(today);
  const disabled =
    !consent ||
    !checkEmptyField(name) ||
    !checkEmptyField(lastname) ||
    gender === -1 ||
    !checkEmptyField(phone) ||
    !checkEmptyField(DateBirth) ||
    isFutureDate;
  return (
    <div className="client-data-root">
      <div className="client-data-root__title title">Ваши контакты</div>
      <form className="client-data-root__form">
        <InputForm
          className="client-data-root__field"
          type="text"
          value={name}
          propertyName="name"
          onChange={inputChangeHandler}
          label="Имя"
        />
        <InputForm
          className="client-data-root__field"
          type="text"
          value={lastname}
          propertyName="lastname"
          onChange={inputChangeHandler}
          label="Фамилия"
        />
        <InputForm
          className="client-data-root__field"
          type="text"
          value={sname}
          propertyName="sname"
          onChange={inputChangeHandler}
          label="Отчество"
        />
        {showGenderInput && (
          <SelectInput
            className="client-data-root__field"
            value={gender}
            name="gender"
            onChange={inputChangeHandler}
            label="Пол"
          >
            <MenuItem value={-1}>Не выбран</MenuItem>
            <MenuItem value={1}>Мужской</MenuItem>
            <MenuItem value={0}>Женский</MenuItem>
          </SelectInput>
        )}
        <InputPhoneMask
          className="client-data-root__field"
          value={phone}
          propertyName="phone"
          onChange={inputChangeHandler}
        />
        {/* <InputForm
          className="client-data-root__field"
          type="email"
          value={email}
          propertyName="email"
          onChange={inputChangeHandler}
          label="Email"
        /> */}
        {/* <InputForm
          className="client-data-root__field"
          type="text"
          value={inn}
          propertyName="inn"
          onChange={inputChangeHandler}
          label="ИНН"
        /> */}
        {/* <InputForm
          className="client-data-root__field"
          type="text"
          value={documentNumber}
          propertyName="documentNumber"
          onChange={inputChangeHandler}
          label="Номер документа"
        /> */}
        <InputForm
          className="client-data-root__field birth-date"
          type="date"
          value={DateBirth}
          propertyName="DateBirth"
          onChange={inputChangeHandler}
          label="Дата рождения"
          inputProps={{
            max: today,
          }}
          error={isFutureDate}
          helperText={
            isFutureDate ? "Дата рождения не может быть в будущем" : ""
          }
        />
      </form>
      <FormControlLabel
        className="client-data-root__consent"
        control={
          <Checkbox
            checked={consent}
            onChange={(e) => setConsent(e.target.checked)}
            name="consent"
            color="primary"
          />
        }
        label={
          <span>
            Я согласен на обработку своих{" "}
            {privacyPolicyUrl ? (
              <a
                className="client-data-root__consent-link"
                href={privacyPolicyUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                персональных данных
              </a>
            ) : (
              <span className="client-data-root__consent-link">
                персональных данных
              </span>
            )}
          </span>
        }
      />
      <div className="d-flex mt-30">
        <GeneralButton
          className="mr-10"
          title="Назад"
          onClick={handleClickPrev}
        />
        <GeneralButton
          title="Далее"
          disabled={disabled}
          onClick={createPatient}
        />
      </div>
    </div>
  );
};

export default ClientForm;
